"use strict";

angular.module("core")
.component("paymentMethodBank", {
    bindings: {
        isPaymentSetting: "<?",
        selectedBankAccount: "=?"
    },
    templateUrl: require("./payment-method-bank.component.html"),
    controllerAs: 'paymentMethodBankCtrl',
    controller: function(
        $scope, $q, gettextCatalog, FlashBag, ModalService, UserService, PaymentMethodsBankService,
        ReadOnlyPermissionService,
        ONBOARDING_USER_VERIFICATION_TYPES, PAYMENT_METHODS
    ) {
        var _this = this;
        $scope.clientAccount = null;
        $scope.isUserCanManagePaymentMethods = false;
        $scope.isUserCanPay = false;
        $scope.isProfileCompleted = false;
        $scope.userVerificationType = ONBOARDING_USER_VERIFICATION_TYPES[PAYMENT_METHODS.BANK_TRANSFER];

        UserService.isUserFetched().then(function onSuccess(user) {
            if (user) {
                if (user.customer) {
                    $scope.isProfileCompleted = user.has_profile_completed["all"];
                    $scope.isUserCanManagePaymentMethods = user.is_user_can_manage_payment_methods;
                    $scope.isUserCanPay = user.is_user_can_pay;
                }
                else if (user.vendor) {
                    $scope.isUserCanManagePaymentMethods = true;
                    $scope.isUserCanPay = true;
                    $scope.isProfileCompleted = true;
                }
            }
        });

        function refreshClientAccount() {
            PaymentMethodsBankService.getClientAccount()
            .then(function onSuccess(response) {
                $scope.clientAccount = response.data;
                _this.selectedBankAccount = $scope.clientAccount.default_bank_account;
            }, function onError() {
                $scope.clientAccount = {};
            });
        }

        refreshClientAccount();

        this.connectBankAccount = function() {
            if (!$scope.isUserCanManagePaymentMethods) {
                return;
            }

            ModalService.showModal({
                templateUrl: require("./modals/payment-methods-bank-account.modal.html"),
                controller: "PaymentMethodsBankAccountModalController",
                controllerAs: "paymentMethodsBankAccountModalCtrl",
                inputs: {
                    $attrs: {}
                }
            }).then(function(modal) {
                modal.element.modal({
                    backdrop: "static",
                    keyboard: false
                });
                modal.element.on("hidden.bs.modal", function(e) {
                    $scope.$emit("requestResetListing");
                    refreshClientAccount();
                    modal.element.remove();
                });
            });
        };

        this.saveDefaultBankAccount = function(bankAccountId) {
            if (!this.isPaymentSetting) {
                this.selectedBankAccount = bankAccountId;
                return;
            }

            if (!$scope.isUserCanManagePaymentMethods) {
                return;
            }

            PaymentMethodsBankService.updateClientAccount(bankAccountId)
            .then(function onSuccess(response) {
                FlashBag.success(gettextCatalog.getString("Default bank account was saved successfully."));
            }, function onError(response) {
                ReadOnlyPermissionService.handleResponseError(response);
                FlashBag.apiError(response);
            }).finally(function() {
                refreshClientAccount();
            });
        };

        this.deleteBankAccount = function(bankAccountId) {
            if (!$scope.isUserCanManagePaymentMethods) {
                return;
            }

            PaymentMethodsBankService.getBankAccount(bankAccountId)
            .then(function onSuccess() {
                // noinspection JSCheckFunctionSignatures,JSVoidFunctionReturnValueUsed
                ModalService.showModal({
                    templateUrl: require("core/confirmation/confirmation.modal.html"),
                    controller: "Confirmation",
                    controllerAs: "ConfirmationCtrl",
                    inputs: {
                        $attrs: {
                            title: gettextCatalog.getString("Bank account delete"),
                            context: gettextCatalog.getString("Your are about to delete a bank account."),
                            message: gettextCatalog.getString("Do you want to continue?", null, "Bank account delete")
                        }
                    }
                }).then(function(modal) {
                    modal.element.modal();
                    modal.element.on("hidden.bs.modal", function(e) {
                        modal.element.remove();
                    });
                    modal.close.then(function(result) {
                        if (result) {
                            PaymentMethodsBankService.deleteBankAccount(bankAccountId)
                            .then(function onSuccess(response) {
                                $scope.$emit("requestResetListing");
                                refreshClientAccount();
                                FlashBag.success(gettextCatalog.getString("Bank account was deleted successfully."));
                            }, function onError(response) {
                                ReadOnlyPermissionService.handleResponseError(response);
                                FlashBag.apiError(response);
                            });
                        }
                    });
                });
            }, function onError(response) {
                FlashBag.apiError(response);
            });
        };
    }
});



//////////////////
// WEBPACK FOOTER
// ./core/payment-methods/payment-method-bank.component.js
// module id = 635
// module chunks = 0